<template>
  <v-app>  
    <SmartAssistant></SmartAssistant>
  </v-app>
</template>

<script setup lang="ts">

</script>
